import { useState, useEffect } from "react";
import { PAY_METHODS } from "./constants";
import { checkDiscount } from "../../../api/discount";
import "../../../styles/panel/user/PaymentStep.css";

// TODO: شماره کارت واقعی رو اینجا جایگزین کن
const CARD_TO_CARD_NUMBER = "6104338801264298";
const CARD_TO_CARD_HOLDER = "گروه مهندسی باورسازان هوشمند";

// روش پرداختی که با زدن دکمه تایید، مودال کارت‌به‌کارت باز میشه
export const isCardToCard = (methodId) => {
  const method = PAY_METHODS.find((m) => m.id === methodId);
  return !!method && method.id?.includes("cart-to-cart");
};

export default function PaymentStep({
  owner,
  store,
  template,
  plan,
  payMethod,
  setPayMethod,
  agreedToRules,
  setAgreedToRules,
  cardTrackingCode,
  setCardTrackingCode,
  showCardModal,
  setShowCardModal,
  onConfirmCardPayment,
  onDiscountApplied,
}) {
  const [copied, setCopied] = useState(false);
  const [logoPreview, setLogoPreview] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [zoomedImage, setZoomedImage] = useState(null); // { src, alt }

  // ---- کد تخفیف ----
  const [discountCode, setDiscountCode] = useState("");
  const [appliedDiscount, setAppliedDiscount] = useState(null); // { code, percent, amount }
  const [discountLoading, setDiscountLoading] = useState(false);
  const [discountError, setDiscountError] = useState("");

  const originalPrice = plan ? Number(plan.price) : 0;
  const finalPrice = appliedDiscount
    ? Math.max(
        0,
        appliedDiscount.percent
          ? originalPrice - (originalPrice * appliedDiscount.percent) / 100
          : originalPrice - (appliedDiscount.amount || 0),
      )
    : originalPrice;

  const handleApplyDiscount = async () => {
    const code = discountCode.trim();
    if (!code) return;
    setDiscountError("");
    setDiscountLoading(true);
    try {
      // بررسی واقعی کد تخفیف از بک‌اند (همون endpoint که در MySitesDashboard استفاده شده)
      const res = await checkDiscount({ code, storeId: store?.id });
      const result = res?.data;

      if (result?.valid) {
        setAppliedDiscount({
          code,
          percent: result?.data?.percentage,
          amount: result?.discount_amount,
        });
      } else {
        setDiscountError(result?.message || "کد تخفیف نامعتبر است");
      }
    } catch (err) {
      setDiscountError(
        err?.response?.data?.detail ||
          err?.response?.data?.message ||
          "خطا در بررسی کد تخفیف",
      );
    } finally {
      setDiscountLoading(false);
    }
  };

  const handleRemoveDiscount = () => {
    setAppliedDiscount(null);
    setDiscountCode("");
    setDiscountError("");
  };

  // ---- ساخت پیش‌نمایش لوگو و تصویر فروشگاه از فایل‌های آپلودشده ----
  useEffect(() => {
    if (!store?.logoFile) {
      setLogoPreview(null);
      return;
    }
    const url = URL.createObjectURL(store.logoFile);
    setLogoPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [store?.logoFile]);

  useEffect(() => {
    if (!store?.imageFile) {
      setImagePreview(null);
      return;
    }
    const url = URL.createObjectURL(store.imageFile);
    setImagePreview(url);
    return () => URL.revokeObjectURL(url);
  }, [store?.imageFile]);

  // ---- به‌روزرسانی کامپوننت والد از کد تخفیف اعمال‌شده (برای ارسال به بک‌اند در زمان ثبت نهایی) ----
  useEffect(() => {
    if (onDiscountApplied) {
      onDiscountApplied(
        appliedDiscount
          ? {
              code: appliedDiscount.code,
              percent: appliedDiscount.percent,
              amount: appliedDiscount.amount,
            }
          : null,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appliedDiscount]);

  console.log(plan);
  const handleCopyCard = () => {
    navigator.clipboard?.writeText(CARD_TO_CARD_NUMBER.replace(/-/g, ""));
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <>
      <h3 className="request-step-title">پرداخت</h3>
      <p className="request-step-sub">
        اطلاعات درخواست رو بررسی و پرداخت رو تکمیل کن
      </p>

      <div className="summary-box">
        {/* ---- اطلاعات مالک ---- */}
        <div className="summary-group-title">اطلاعات مالک</div>
        <div className="summary-row">
          <span className="k">مالک</span>
          <span className="v">{owner?.fullName || owner?.mobile}</span>
        </div>

        {/* ---- اطلاعات فروشگاه ---- */}
        <div className="summary-group-title">اطلاعات فروشگاه</div>
        {logoPreview && (
          <div className="summary-row">
            <span className="k">لوگوی فروشگاه</span>
            <span className="v">
              <img
                src={logoPreview}
                alt="لوگوی فروشگاه"
                className="summary-thumb"
                onClick={() =>
                  setZoomedImage({ src: logoPreview, alt: "لوگوی فروشگاه" })
                }
              />
            </span>
          </div>
        )}
        {imagePreview && (
          <div className="summary-row">
            <span className="k">تصویر فروشگاه</span>
            <span className="v">
              <img
                src={imagePreview}
                alt="تصویر فروشگاه"
                className="summary-thumb"
                onClick={() =>
                  setZoomedImage({ src: imagePreview, alt: "تصویر فروشگاه" })
                }
              />
            </span>
          </div>
        )}
        <div className="summary-row">
          <span className="k">نام فروشگاه</span>
          <span className="v">{store?.storeName || "—"}</span>
        </div>
        <div className="summary-row">
          <span className="k">دسته فروشگاه</span>
          <span className="v">
            {store?.categoryName || store?.category || "—"}
          </span>
        </div>
        <div className="summary-row">
          <span className="k">آدرس سایت</span>
          <span className="v">{store?.slug || "—"}</span>
        </div>
        <div className="summary-row">
          <span className="k">استان</span>
          <span className="v">
            {store?.provinceName || store?.province || "—"}
          </span>
        </div>
        <div className="summary-row">
          <span className="k">شهر</span>
          <span className="v">{store?.cityName || store?.city || "—"}</span>
        </div>
        <div className="summary-row">
          <span className="k">شماره ثابت فروشگاه</span>
          <span className="v">{store?.landline || "—"}</span>
        </div>
        <div className="summary-row">
          <span className="k">موبایل فروشگاه</span>
          <span className="v">{store?.mobile || "—"}</span>
        </div>

        {/* ---- قالب و پلن ---- */}
        <div className="summary-group-title">قالب و پلن</div>
        <div className="summary-row">
          <span className="k">قالب انتخاب‌شده</span>
          <span className="v">{template ? template.name : "—"}</span>
        </div>
        <div className="summary-row">
          <span className="k">پلن</span>
          <span className="v">{plan ? plan.name : "—"}</span>
        </div>
        {/* <div className="summary-row">
          <span className="k">مدت اعتبار</span>
          <span className="v">
            {plan?.duration
              ? `${plan.duration} ${plan.durationUnit || "ماه"}`
              : "—"}
          </span>
        </div> */}

        {/* ---- کد تخفیف ---- */}
        <div className="summary-group-title">کد تخفیف</div>
        <div className="discount-row">
          <input
            type="text"
            className="discount-input"
            placeholder="کد تخفیف را وارد کنید"
            value={appliedDiscount ? appliedDiscount.code : discountCode}
            onChange={(e) => setDiscountCode(e.target.value)}
            disabled={!!appliedDiscount || discountLoading}
          />
          {appliedDiscount ? (
            <button
              type="button"
              className="discount-btn"
              onClick={handleRemoveDiscount}
            >
              حذف
            </button>
          ) : (
            <button
              type="button"
              className="discount-btn"
              onClick={handleApplyDiscount}
              disabled={!discountCode.trim() || discountLoading}
            >
              {discountLoading ? "در حال بررسی..." : "ثبت"}
            </button>
          )}
        </div>
        {discountError && <div className="discount-error">{discountError}</div>}

        {/* ---- قیمت ---- */}
        <div className="summary-group-title">قیمت</div>
        <div
          className={`summary-row${appliedDiscount ? " price-original" : " total"}`}
        >
          <span className="k">
            {appliedDiscount ? "قیمت قبل از تخفیف" : "قیمت"}
          </span>
          <span className="v">
            {plan
              ? `${originalPrice.toLocaleString("en-US")} هزار تومان / ماه`
              : "—"}
          </span>
        </div>
        {appliedDiscount && (
          <div className="summary-row total">
            <span className="k">قیمت بعد از تخفیف</span>
            <span className="v discount-final">
              {`${finalPrice.toLocaleString("en-US")} هزار تومان / ماه`}
            </span>
          </div>
        )}
      </div>

      {zoomedImage && (
        <div className="modal-overlay" onClick={() => setZoomedImage(null)}>
          <div
            className="image-preview-box"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="modal-close image-preview-close"
              onClick={() => setZoomedImage(null)}
              aria-label="بستن"
            >
              ×
            </button>
            <img src={zoomedImage.src} alt={zoomedImage.alt} />
          </div>
        </div>
      )}

      <div className="pay-methods">
        {PAY_METHODS.map((m) => (
          <div
            key={m.id}
            className={`pay-method${payMethod === m.id ? " selected" : ""}`}
            onClick={() => setPayMethod(m.id)}
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              {m.icon}
            </svg>
            <div className="pay-method-text">
              <div className="t">{m.title}</div>
              <div className="s">{m.sub}</div>
            </div>
          </div>
        ))}
      </div>

      {showCardModal && (
        <div className="modal-overlay" onClick={() => setShowCardModal(false)}>
          <div className="modal-box" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h4>پرداخت کارت به کارت</h4>
              <button
                type="button"
                className="modal-close"
                onClick={() => setShowCardModal(false)}
                aria-label="بستن"
              >
                ×
              </button>
            </div>

            <p className="modal-desc">
              لطفاً مبلغ مورد نظر را به شماره کارت ۶۱۰۴-۳۳۸۸-۰۱۲۶-۴۲۹۸ به نام
              <b> گروه مهندسی باورسازان هوشمند </b>(بانک ملت) واریز نمایید. سپس
              شماره تراکنش را درج کنید. حداکثر تا ۳۰ دقیقه پس از بررسی واریزی،
              فروشگاه فعال خواهد شد.
            </p>

            <div className="card-number-box">
              <span className="card-number-value">{CARD_TO_CARD_NUMBER}</span>
              <button
                type="button"
                className="card-copy-btn"
                onClick={handleCopyCard}
              >
                {copied ? "کپی شد" : "کپی"}
              </button>
            </div>
            <div className="card-holder-name">{CARD_TO_CARD_HOLDER}</div>

            <div className="modal-field">
              <label htmlFor="cardTrackingCode">شناسه واریز</label>
              <input
                id="cardTrackingCode"
                type="text"
                value={cardTrackingCode || ""}
                onChange={(e) => setCardTrackingCode(e.target.value)}
                placeholder="مثلاً 123456789"
                inputMode="numeric"
              />
            </div>

            <button
              type="button"
              className="request-btn primary modal-confirm"
              disabled={!cardTrackingCode}
              onClick={() => {
                setShowCardModal(false);
                onConfirmCardPayment &&
                  onConfirmCardPayment(
                    isCardToCard(payMethod) ? "card_to_card" : "gateway",
                    cardTrackingCode,
                    appliedDiscount
                      ? {
                          code: appliedDiscount.code,
                          percent: appliedDiscount.percent,
                          amount: appliedDiscount.amount,
                        }
                      : null,
                  );
              }}
            >
              تایید و پرداخت
            </button>
          </div>
        </div>
      )}

      <label className="rules-agree">
        <input
          type="checkbox"
          checked={agreedToRules}
          onChange={(e) => setAgreedToRules(e.target.checked)}
        />
        <span>
          <a href="/rules" target="_blank" rel="noopener noreferrer">
            قوانین و مقررات
          </a>{" "}
          را خوانده‌ام و با آن‌ها موافقم
        </span>
      </label>
    </>
  );
}

export function isPaymentStepValid(payMethod, agreedToRules) {
  return !!payMethod && !!agreedToRules;
}
